import React, { PropTypes } from 'react'
import './style.less'

function HeRow({ children, img, headline, cta, align }) {
  return (
    <div className="row between-xs hero-row center-xs">
      <div className={`col-xs-12 col-sm-12 col-md image-cell ${align === 'right' && 'last-md'}`}>
				{img}
      </div>
      <div className="col-xs-12 col-sm-12 col-md-5 content-cell">
        <div className={`content ${align}`}>
          {children}
        </div>
      </div>
    </div>
  )
}

HeRow.propTypes = {
  children: PropTypes.node,
  img: PropTypes.node,
  align: PropTypes.oneOf(['left', 'right'])
}

HeRow.defaultProps = {
  children: null,
  img: null,
  align: 'left'
}

export default HeRow



// WEBPACK FOOTER //
// ../components/HeRow/index.js